import React from 'react'

import { Checkbox } from '@fourthwall/components'

import * as S from './AnalyticsFiltersSelect.styled'
import type { AnalyticsFiltersSelectProps } from './AnalyticsFiltersSelect.types'

export const AnalyticsFiltersSelect = ({ filters, onChange }: AnalyticsFiltersSelectProps) => {
  const handleCheckboxChange = (sectionTitle: string, itemValue: string, checked: boolean) =>
    onChange(sectionTitle, itemValue, checked)

  const visibleFilters = filters.filter((section) => {
    if (section.enabled === false) return false

    if (!section.items || section.items.length === 0) return false

    const hasEnabledItems = section.items.some((item) => item.enabled !== false)
    if (!hasEnabledItems) return false

    return true
  })

  return (
    <S.Container>
      {visibleFilters.map(({ title, items }, index) => {
        const visibleItems = items.filter((item) => item.enabled !== false)

        if (visibleItems.length === 0) return null

        return (
          <React.Fragment key={title}>
            <S.Section>
              <S.SectionTitle>{title}</S.SectionTitle>
              {visibleItems.map((item) => {
                const itemKey = Array.isArray(item.value) ? item.value[0] : item.value
                const itemValue = Array.isArray(item.value) ? item.value[0] : item.value

                return (
                  <S.SelectItem key={itemKey}>
                    <Checkbox
                      native
                      label={item.label}
                      value={itemValue}
                      checked={item.checked}
                      onValueChange={(checked) => handleCheckboxChange(title, itemValue, checked)}
                    />
                  </S.SelectItem>
                )
              })}
            </S.Section>
            {index + 1 < visibleFilters.length && <S.Divider />}
          </React.Fragment>
        )
      })}
    </S.Container>
  )
}
